<template>
    <a-spin :tip="loadingTip" :spinning="isloading">
        <div class>
            <a-form :form="form" @submit="handleSubmit">
                <a-form-item label="标题" :label-col="{ span: 3 }" :wrapper-col="{ span: 19 }">
                    <a-input
                            placeholder="请输入标题"
                            v-decorator="[
          'title',
          {rules: [{ required: true, message: '请输入标题!' }],initialValue:info.title}
        ]"
                    ></a-input>
                </a-form-item>

                <a-form-item label="消息类型" :label-col="{ span: 3 }" :wrapper-col="{ span: 19 }">
                    <a-radio-group @change="onChangeAll" v-model="info.type"
                                   v-decorator="[
          'type',
          {rules: [{ required: true, message: '请选择发送方式!' }],initialValue:info.type}
        ]">
                        <a-radio  value="shortmessage">站内信</a-radio>
                        <a-radio value="sms">短信</a-radio>
                    </a-radio-group>
                </a-form-item>
                <a-form-item label="内容" :label-col="{ span: 3 }" :wrapper-col="{ span: 19 }">
                    <a-textarea
                            placeholder="请输入内容"
                            :autosize="{ minRows: 4, maxRows: 6 }"
                            v-decorator="[
          'content',
          {rules: [{ required: true, message: '请输入内容!' }],initialValue:info.content}
        ]"
                    />
                </a-form-item>
                <a-row :gutter="24">
                    <a-col :offset="3" :span="8">
                        <pxkeji-btn
                                name="选择用户"
                                class="pxkeji_basic_btn"
                                @click="selectStudent()"
                                type="primary"
                        />
                    </a-col>
                </a-row>
                <a-table
                        :columns="list.columns"
                        rowKey="id"
                        :pagination="list.pagination"
                        @change="onChange"
                        :dataSource="list.datas"
                        :loading="isloading"
                        :locale="{emptyText:'暂无数据'}"
                >
      <span slot="action" slot-scope="action">
        <span v-if="action.area">{{action.province}}/{{action.city}}/{{action.area}}</span>
      </span>
                </a-table>
                <a-form-item :wrapper-col="{ span: 5, offset: 10 }">
                    <pxkeji-btn name="发送" type="primary" htmlType="submit"/>
                </a-form-item>
            </a-form>
        </div>
        <a-modal
                title="选择用户"
                v-model="userList.visible"
                :footer="false"
                destroyOnClose
                :maskClosable="false"
                width="80%"
        >
            <selectUser :id="studentList" @callbackMethod="selectUserBack"/>
        </a-modal>
    </a-spin>
</template>

<script>
    import selectUser from "./messageSelectUser.vue";

    var that;
    const columns = [
        {
            dataIndex: "fullName",
            key: "fullName",
            align: "center",
            title: "学员名称",
        },
        {
            dataIndex: "telephone",
            key: "telephone",
            align: "center",
            title: "手机号",
        },
        {
            dataIndex: "idCard",
            key: "idCard",
            align: "center",
            title: "身份证号",
        },
        {
            dataIndex: "sex",
            key: "sex",
            align: "center",
            title: "性别",
        },
        {
            key: "action",
            align: "center",
            title: "地区",
            scopedSlots: {customRender: "action"},
        },
        {
            dataIndex: "enterprise.name",
            key: "enterpriseName",
            align: "center",
            title: "所属单位",
        },
        {
            dataIndex: "extensions.groupName",
            key: "groupName",
            align: "center",
            title: "管理组名称",
        },
    ];
    export default {
        props: {
            id: String,
        },
        data() {
            return {
                list: {
                    columns, //表头
                    datas: [], //数据
                    pagination: {
                        //分页器
                        showQuickJumper: true,
                        hideOnSinglePage: true,
                        total: 0,
                        current: 1, //页码
                        defaultPageSize: 10, //页容
                    },
                },
                form: this.$form.createForm(this),
                info: {
                    userIds: [],
                },
                userList: {
                    visible: false,
                },
                studentList: [],
                isloading: false,
                loadingTip: "加载中...",
                where: {
                    //查询条件
                    keyword: {
                        //搜索条件
                        name: "",
                        company: "",
                        studentIds: "",
                        provience: "",
                        city: "",
                        area: "",
                        groupIds: "",
                    }
                },
            };
        },
        components: {
            selectUser,
        },
        mounted() {
            this.$nextTick(function () {
                that = this;
                if (this.id != "0") {
                    this.getInfo();
                }
            });
        },
        methods: {

            onChangeAll(e) {
                this.info.type = e.target.value;
            },
            selectStudent() {
                this.userList.visible = true;
            },
            GetList() {
                //获取列表
                this.isloading = true;
                var params = {
                    pageNow: this.list.pagination.current,
                    pageSize: this.list.pagination.defaultPageSize,
                    name: this.where.keyword.name,
                    enterpriseName: this.where.keyword.company,
                    studentIds: this.where.keyword.studentIds,
                };
                if (this.where.keyword.groupIds) {
                    params.groupId = this.where.keyword.groupIds;
                }
                if (this.where.keyword.area) {
                    params.province = this.where.keyword.province;
                    params.city = this.where.keyword.city;
                    params.area = this.where.keyword.area;
                }
                this.$api.student
                    .getPagedList(params)
                    .then((res) => {
                        this.isloading = false;
                        if (res.errorCode == this.$msg.responseCode.success) {
                            this.list.datas = res.data.records;
                            for (let i = 0; i < this.list.datas.length; i++) {
                                var ex = this.list.datas[i].extensions;
                                this.list.datas[i].extensions = JSON.parse(ex);
                            }
                            this.list.pagination.total = Number(res.data.total);
                        } else {
                            that.$message.error(res.errorMsg);
                        }
                    })
                    .catch(() => {
                        this.isloading = false;
                    });
            },
            selectUserBack(name, company, studnetIds, provience, city, area, groupIds) {
                //获取列表
                this.isloading = true;
                this.$api.order
                    .getStudentList(name, company, studnetIds, provience, city, area, groupIds)
                    .then((res) => {
                        this.isloading = false;
                        if (res.errorCode == this.$msg.responseCode.success) {
                            this.where.keyword.name = name == null ? "" : name;
                            this.where.keyword.enterpriseName = company;
                            this.where.keyword.studentIds = studnetIds;
                            this.where.keyword.provience = provience;
                            this.where.keyword.city = city;
                            this.where.keyword.area = area;
                            this.where.keyword.groupIds = groupIds;
                            this.userList.visible = false;
                            this.studentList = res.data
                            this.GetList();
                        } else {
                            that.$message.error(res.errorMsg);
                        }
                    })
                    .catch(() => {
                        this.isloading = false;
                    });
            },

            getInfo() {
                this.isloading = true;
                this.$api.notice
                    .getById(this.id)
                    .then((res) => {
                        this.isloading = false;
                        if (res.errorCode == this.$msg.responseCode.success) {
                            this.info = res.data;
                        } else {
                            this.error(res.errorMsg);
                        }
                    })
                    .catch(() => {
                        this.isloading = false;
                    });
            },
            handleSubmit(e) {
                e.preventDefault();
                this.form.validateFields((err, values) => {
                    if (!err) {
                        if (this.studentList.length == 0) {
                            this.$message.error("请选择用户");
                            return;
                        }
                        //新增
                        this.isloading = true;
                        this.loadingTip = "保存中...";
                        this.$api.message
                            .save(
                                values.content,
                                this.info.type,
                                this.studentList.join(","),
                                values.title
                            )
                            .then((res) => {
                                this.isloading = false;
                                if (res.errorCode == this.$msg.responseCode.success) {
                                    this.$message.success(res.errorMsg);
                                    this.$emit("callbackMethod");
                                } else {
                                    this.$message.error(res.errorMsg);
                                }
                            })
                            .catch(() => {
                                this.isloading = false;
                            });

                    }
                });
            },
            onChange(page) {
                //页面切换回调

                this.list.pagination.current = page.current;

                this.GetList();
            },
            onRowChange(selectedRowKeys) {
                this.selectRows = selectedRowKeys;
                this.allSelectRows[this.list.pagination.current] = selectedRowKeys;
            },
            error(msg) {
                this.$error({
                    title: "提示",
                    content: msg == undefined ? "服务器异常" : msg,
                    okText: "返回",
                    centered: true,
                    onOk() {
                        that.$emit("callbackMethod");
                    },
                });
            },
        },
    };
</script>
<style>
</style>